import { Icon, List } from "components/index";
import { PENDING, SUBMITTED } from "icons";

import { Badge } from "ui/components/badge";
import { EmployeeCell } from "components/cell/employee/cell";
import PerformanceStatusCell from "@/modules/performance/components/cells/status";
import { RenderProfile } from "components/render-profile";
import classNames from "classnames";
import { getUserFields } from "components/user/config";
import { useParams } from "react-router-dom";
import { StatusCell } from "@/components/status/cell";

const GivenFeedbacks = () => {
  const { quadId } = useParams();

  const fields = [
    "id",
    getUserFields("reviewee"),
    getUserFields("reviewee.reports_to"),
    "status",
    "self_nominated",
  ];

  const columns = [
    {
      header: "Employee",
      accessorKey: "reviewee",
      cell: ({ getValue }) => <RenderProfile user={getValue()} />,
    },
    {
      header: "Type",
      accessorKey: "self_nominated",
      cell: ({ getValue }) => (getValue() ? "Nominated" : "System"),
    },
    {
      header: "Department",
      accessorKey: "reviewee.department.name",
      cell: ({ getValue }) => {
        if (!getValue()) return null;
        return <Badge variant="outline">{getValue()}</Badge>;
      },
    },
    {
      header: "Reports to",
      accessorKey: "reviewee.reports_to",
      cell: EmployeeCell,
    },
    {
      header: "Status",
      accessorKey: "status",
      cell: StatusCell,
    },
  ];

  const filters = {
    reviewer: {
      user: { _eq: "$CURRENT_USER" },
    },
    reviewee: {
      user: { _neq: "$CURRENT_USER" },
    },
    quadrimester: {
      _eq: quadId,
    },
  };
  return (
    <div key={quadId} className={"flex-1"}>
      <List
        title="Given Feedbacks"
        endPoint="performance_review"
        meta={{ fields }}
        columns={columns}
        storageKey={`performance_given_feedbacks-${quadId}`}
        filters={filters}
        href={(item) => `${item.id}/edit`}
        showSearch={false}
      />
    </div>
  );
};

export default GivenFeedbacks;
